import {ApolloClient,ApolloLink, InMemoryCache, HttpLink} from 'apollo-boost';
import {onError} from 'apollo-link-error';
import {forceLogout} from './session';

const httpLink = new HttpLink({ uri: process.env.REACT_APP_GRAPH_API });
const authMiddleware = new ApolloLink((operation, forward) => {
    // add the authorization to the headers
    operation.setContext({
        headers: {
            authorization: `bearer ${localStorage.getItem('token')}`,
        }
    });

    return forward(operation);
})

// Ends the session as soon as the server says the token is no longer good.
//
// Without this a token that expired, or that was signed with a secret since
// rotated, left every request failing on its own. The client tried to parse the
// 401 body as JSON, failed, and passed a parser error up to be displayed - so the
// user was shown "Unexpected token 'U', ..." instead of being signed out. The
// server now answers 401 with JSON, and this acts on it.
//
// Only 401. A 403 means the caller is known but not allowed, and signing them out
// for asking would be wrong.
const sessionExpiryLink = onError(({networkError}) => {
    if (networkError && networkError.statusCode === 401) {
        forceLogout();
    }
});

export const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: authMiddleware.concat(sessionExpiryLink).concat(httpLink),
});
